import { TPortalSeeAllMode } from '@/src/providers';

const portalSeeAllLabels: Partial<Record<TPortalSeeAllMode, string>> = {
  photoSessions: 'Фотосессии',
  aiVideos: 'Видео',
  bestItems: 'Лучшее',
  limited: 'Лимитированные',
  stickers: 'Стикеры',
  styles: 'Стили',
  videoStyleCategories: 'Видео',
  effectsCategories: 'Эффекты',
  effects: 'Эффекты',
  videoVeo3: 'Видео Veo3',
  storyLines: 'Сторилайны',
};

export const getBlockName = (mode: TPortalSeeAllMode): string | null => {
  if (!mode) {
    return null;
  }
  return portalSeeAllLabels[mode] ?? null;
};
